export const INTERVIEW_CANCELED_STATUSES = ['rejected', 'failed', 'entered-in-error'];
export const INTERVIEW_ACTIVE_STATUSES = [
  'draft',
  'requested',
  'received',
  'accepted',
  'ready',
  'in-progress',
  'on-hold',
  'completed',
  'cancelled'
];
